module.exports = __webpack_public_path__ + "img/18.2f619dc9.jpg";